import React from "react"

import "./_playlist-404.scss"

const PlaylistForm = ({ country }) => {
  return (
    <div className="playlist-404">
      <h3> This is awkward... we don't have a playlist yet...</h3>
      <p>Help us discover {country}</p>
      <div className="Playlist-404__form">
        <form
          target="_blank"
          action="https://docs.google.com/forms/d/e/1FAIpQLSc9LTFUFM2fbiPMP37X0PnbASGWAU36_rf88pi9GKFAv7vD0g/viewform"
        >
          <input type="submit" value="SUGGEST AN ARTIST" />
        </form>
      </div>
    </div>
  )
}

export default PlaylistForm
